import { action, makeObservable, observable } from "mobx";
import AuthStore from "./auth/AuthStore";
import EditAgentStore from "./agents/pages/EditAgentStore";
import NewCampaignStore from "./campaigns/NewCampaignStore";
// [DEPRECATED_GRAPHQL] - Para eliminación: ContactStore usa GraphQL queries (getData, getSingleContact, putSingleContact)
// TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente

// import ContactStore from "./campaigns/ContactStore";
import NotificationStore from "./notifications/NotificationStore";
import ProfileStore from "./profile/ProfileStore";
import AgentStore from "./agents/AgentStore";
import ConversationsStore from "./conversations/ConversationsStore";
import HistoryAgentStore from "./agents/pages/HistoryAgentStore";
import AssistanceUCPStore from "./unifiedCustomerProfile/AssistanceUCPStore";
// [DEPRECATED_GRAPHQL] - Para eliminación: AlertStore usa GraphQL queries
// TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente

// import AlertStore from "./alerts/AlertsStore";
import NotesStore from "./notes/NotesStore";
import InstructionsStore from "./playground/InstructionsStore";
import ToolsStore from "./playground/ToolsStore";
import KnowledgeStore from "./playground/knowledgeStore"
import FileStore from "./playground/fileStore"
import PlaygroundConfigStore from "./playground/configStore"
import DocumentStore from "./playground/documentStore"
import PlaygroundAgentStore from "./playground/agentStore"
import BreadcrumbStore from "./breadcrumb/BreadcrumbStore"
import AgentListStore from "./playground/agentListStore"
import chatDocumentsStoreInstance from "./documents/documentsStore"

// v2 stores
import DrivesStore from "./v2/drives/DrivesStore";
import FoldersStore from "./v2/folders/FoldersStore";
import DocumentsStore from "./v2/documents/DocumentsStore";
import FilesStore from "./v2/files/FilesStore";
import AgentsStore from "./v2/agents/AgentsStore";
import ResourcesStore from "./v2/resources/ResourcesStore";
import UsersStore from "./v2/users/UsersStore";
import WorkspaceStore from "./v2/workspace/WorkspaceStore";
import DepartmentsStore from "./departments/DepartmentsStore";

class Store {
  title = "";

  authStore = new AuthStore();
  newCampaign = new NewCampaignStore();
  editAgent = new EditAgentStore();
  notificationStore = new NotificationStore();
  profileStore = new ProfileStore();
  // [DEPRECATED_GRAPHQL] - Para eliminación: ContactStore usa GraphQL queries
  // TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente

  // contactStore = new ContactStore();
  agentStore = new AgentStore();
  conversationsStore = new ConversationsStore();
  historyAgentStore = new HistoryAgentStore();
  assistanceUCPStore = new AssistanceUCPStore();
  // [DEPRECATED_GRAPHQL] - Para eliminación: AlertStore usa GraphQL queries
  // alertStore = new AlertStore();
  notesStore = new NotesStore();
  instructionsStore = new InstructionsStore();
  toolsStore = new ToolsStore();



  

  // Initialize base stores first
  agentListStore = new AgentListStore();
  documentStore = new DocumentStore();
  fileStore = new FileStore();
  breadcrumbStore = new BreadcrumbStore();

  // Initialize dependent stores with injected dependencies
  playgroundAgentStore = new PlaygroundAgentStore(this.agentListStore);
  playgroundConfigStore = new PlaygroundConfigStore(this.playgroundAgentStore);
  knowledgeStore = new KnowledgeStore(this.playgroundAgentStore);
  
  // Drive general stores
  drivesStore = new DrivesStore();
  foldersStore = new FoldersStore();
  documentsStore = new DocumentsStore();
  filesStore = new FilesStore();
  agentsStore = new AgentsStore();
  resourcesStore = new ResourcesStore();
  usersStore = new UsersStore();
  workspaceStore = new WorkspaceStore();
  departmentsStore = new DepartmentsStore();
  
  // Chat documents store (singleton instance)
  chatDocumentsStore = chatDocumentsStoreInstance;
 
	constructor() {
    makeObservable(this, {
      title: observable,
      authStore: observable,
      editAgent: observable,
      notificationStore: observable,
      profileStore: observable,
      // [DEPRECATED_GRAPHQL] - Para eliminación: ContactStore usa GraphQL queries
      // TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente

      // contactStore: observable,
      changeTitle: action,
      agentStore: observable,
      conversationsStore: observable,
      historyAgentStore: observable,
      assistanceUCPStore: observable,
      // [DEPRECATED_GRAPHQL] - Para eliminación: AlertStore usa GraphQL queries
      // alertStore: observable,
      notesStore: observable,
      instructionsStore: observable,
      // Base stores
      agentListStore: observable,
      documentStore: observable,
      fileStore: observable,
      breadcrumbStore: observable,

      // Dependent stores
      playgroundAgentStore: observable,
      playgroundConfigStore: observable,
      knowledgeStore: observable,
      
      // Drive general stores
      drivesStore: observable,
      foldersStore: observable,
      documentsStore: observable,
      filesStore: observable,
      agentsStore: observable,
      resourcesStore: observable,
      usersStore: observable,
      workspaceStore: observable,
      departmentsStore: observable,
      
      // Chat documents store
      chatDocumentsStore: observable,
    });
  }

  changeTitle = (title) => {
    this.title = title;
  };
  

  globalConstants = () => {
    return {
      userRoleGroups: ["superadmin", "customeradmin", "user"],
      onboardingTemplate: {
        isKeyReady: false,
        isCampaingReady: false,
        isChannelReady: false,
        isAssistantReady: false,
      },
    };
  };
}

const DefaultStore = new Store();
export default DefaultStore;
